import React from 'react';

import { SuccessMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import useText from '@hooks/use-text';

import GoogleLogo from './GoogleLogo';

export const GooglePayAlreadyActivatedMessage = () => {
    const { googleWalletAlreadyAddedGooglePayPart1, googleWalletAlreadyAddedGooglePayPart2 } = useText();

    return (
        <SuccessMessage
            id="card-already-registered"
            icon={IconTypes.CHECKMARK_LISTE_24}
            text={
                <>
                    <span>{googleWalletAlreadyAddedGooglePayPart1}</span>
                    <span className="google-pay-icon">
                        <GoogleLogo />
                    </span>
                    <span>{googleWalletAlreadyAddedGooglePayPart2}</span>
                </>
            }
        />
    );
};
